import React, { useEffect, useRef, useState } from "react";

const UserRegistrationInfo = (props) => {
  const infoForm = useRef(null);
  const [userRegistrationData, setUserRegistrationData] = useState({});
  const [customerTimeline, setTimeline] = useState("TODAY");
  const [searchdata, setSearchdata] = useState({});

  const userRegistrationCardData = [
    {
      id: "totalusers",
      title: "Total Users",
      count: userRegistrationData?.totalusers || 0,
      icon: imagepaths.AdminLeadsIconActive,
      path: `/app/portfolioinfo?cardname=totalUsers&tablename=customer&customerTimeline=${searchdata?.customerStartDate ? "CUSTOM" : customerTimeline
        }&start_date=${searchdata?.customerStartDate || null}&end_date=${searchdata?.customerEndDate || null
        }`,
    },
    {
      id: "pendingusers",
      title: "Profile Pending",
      count: userRegistrationData?.pendingusers || 0,
      icon: imagepaths.userWarningIcon,
      path: `/app/portfolioinfo?cardname=pending&tablename=customer&customerTimeline=${searchdata?.customerStartDate ? "CUSTOM" : customerTimeline
        }&start_date=${searchdata?.customerStartDate || null}&end_date=${searchdata?.customerEndDate || null
        }`,
    },
    {
      id: "completedusers",
      title: "Profile Completed",
      count: userRegistrationData?.completedusers || 0,
      icon: imagepaths.userCheckmarkIcon,
      path: `/app/portfolioinfo?cardname=completed&tablename=customer&customerTimeline=${searchdata?.customerStartDate ? "CUSTOM" : customerTimeline
        }&start_date=${searchdata?.customerStartDate || null}&end_date=${searchdata?.customerEndDate || null
        }`,
    },
    {
      id: "appliedusers",
      title: "Applied",
      count: userRegistrationData?.appliedusers || 0,
      icon: imagepaths.userRightIcon,
      path: `/app/portfolioinfo?cardname=applied&tablename=customer&customerTimeline=${searchdata?.customerStartDate ? "CUSTOM" : customerTimeline
        }&start_date=${searchdata?.customerStartDate || null}&end_date=${searchdata?.customerEndDate || null
        }`,
    },
  ];
  // USER REGISTRATIONS
  const getRegisteredUsers = (query, params) => {
    let data = {
      ...(params && params === "CUSTOM"
        ? {
          ...query,
          customerTimeline: "CUSTOM",
        }
        : {
          ...query,
          customerTimeline: customerTimeline,
        }),
    };
    // console.log({ params, data, customerTimeline });

    props.apis.apiGetAdminDashboardPipeline(data).then((res) => {
      setUserRegistrationData((prevState) => ({
        ...prevState,
        totalusers: res?.customers?.total,
        pendingusers: res?.customers?.pendingProfile,
        completedusers: res?.customers?.completedProfile,
        appliedusers: res?.customers?.applied,
      }));
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "registration-column-customerStartDate",
      "registration-column-customerEndDate",
      "registration-column-search_btn",
      "registration-column-reset_btn",
    ];
    // console.log({ val });
    props.onTimelineChange(val);
    if (val === "CUSTOM") {
      showInputs(inputs);
      setUserRegistrationData();
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["customerTimeline"]),
    };
    console.log({ queryData });

    props.onCustomTimelineChange(queryData);
    setSearchdata(queryData);
    getRegisteredUsers(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "registration-column-customerStartDate",
      "registration-column-customerEndDate",
      "registration-column-search_btn",
      "registration-column-reset_btn",
    ];
    props.onCustomTimelineChange({});
    hideInputs(inputs);
    getRegisteredUsers({}, "TODAY");
  };

  useEffect(() => {
    // USER REGISTRATIONS
    getRegisteredUsers({}, customerTimeline);
  }, [customerTimeline]);

  useEffect(() => {
    if (props.data) {
      setUserRegistrationData((prevState) => ({
        ...prevState,
        totalusers: props.data?.totalusers,
        pendingusers: props.data?.pendingusers,
        completedusers: props.data?.completedusers,
        appliedusers: props.data?.appliedusers,
      }));
    }
  }, [props.data]);

  props.$setNode({
    props,
    userRegistrationData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-customerTimeline"
            >
              <AppInputFocus
                type="select"
                name="customerTimeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="registration-column-customerStartDate"
            >
              <AppInputFocus
                type="date"
                name="customerStartDate"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="registration-column-customerEndDate"
            >
              <AppInputFocus
                type="date"
                name="customerEndDate"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="registration-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="registration-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Search</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0 pt-md-4">
          {userRegistrationCardData &&
            userRegistrationCardData.map((data) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    onClick={(...args) => navigate(data?.path)}
                  >
                    <div className="card dashboard_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon">
                          <img src={data?.icon} alt="AdminLeadsIconActive" />
                        </div>
                        <div className="content">
                          <p className="count">{data?.count}</p>
                          <p className="card_label">{data?.title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(UserRegistrationInfo);
